// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Bu-_","requiredAsterisk":"Info_requiredAsterisk__183zk"};